import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import classname from 'classnames';

import Button from '../../../shared/button.component';
import { OptionPropTypes } from '../../../shared/propTypes/common';

import Attachments from '../../../shared/forms/attachments.component';
import FormControl from '../../../shared/forms/formControl.component';
import Select from '../../../shared/reactSelect/select.component';
import TextArea from '../../../shared/forms/textarea/textarea.component';

import { selectPeriodFrom } from '../../aggregationMenu/store/selectors';
import {
  accountsSelector,
} from '../../store/selectors';

import { FormOptionsPropTypes } from './propTypes';
import { AMOUNT_HAS_CHANGED_ERROR_MESSAGE } from './constants';
import { RECLASS_ACCOUNT_ID_ERROR } from '../../shared/taxEntry.constants';

class PopupForm extends PureComponent {
  static propTypes = {
    formData: FormOptionsPropTypes.isRequired,
    formOptions: FormOptionsPropTypes,
    triedToSubmitForm: PropTypes.bool.isRequired,

    formHasRequiredFields: PropTypes.bool.isRequired,
    showDetails: PropTypes.bool.isRequired,
    toggleDetails: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,

    period: PropTypes.shape({
      value: PropTypes.string,
    }).isRequired,
    accounts: PropTypes.arrayOf(OptionPropTypes).isRequired,

    addFile: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    changeProperty: PropTypes.func.isRequired,
    selectProperty: PropTypes.func.isRequired,
    areReclassAccountIdsUnique: PropTypes.bool.isRequired,
    validate: PropTypes.func.isRequired,
    validationSubscription: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { allowSelectingFbosFlag } = this.props.formOptions;

    if (allowSelectingFbosFlag) {
      this.setFbosFlag(true);
    } else {
      this.setFbosFlag(false);
    }
  }

  setFbosFlag = value => {
    const { selectProperty } = this.props;

    selectProperty('fbosFlag', { value });
  };

  selectGlAccountOverride = value => {
    const { selectProperty } = this.props;

    selectProperty('glAccountOverride', value);
  };

  selectAdjustment = value => {
    const { selectProperty } = this.props;

    selectProperty('taxEntryAccountId', value);
  };

  selectFromAdjustment = value => {
    const { selectProperty } = this.props;

    selectProperty('fromTaxEntryAccountId', value);
  };

  render() {
    const {
      formData,
      formOptions,
      triedToSubmitForm,

      formHasRequiredFields,
      showDetails,
      toggleDetails,
      onSubmit,

      accounts,

      addFile,
      removeFile,
      changeProperty,
      validate,
      validationSubscription,

      areReclassAccountIdsUnique,
    } = this.props;

    const {
      amountHasChanged,
      glAccountOverride,
      taxEntryAccountId,
      fromTaxEntryAccountId,
      comment,
      files,
      topsideFlag,
      fbosFlag,
    } = formData;

    const {
      accountOverride,
      glAccounts,
      requireAccount,
      allowFromAccount,
      allowTopside,
      allowSelectingFbosFlag,
      allowSelectingGlAccount,
    } = formOptions;

    const glAccountsToChooseFrom = glAccounts
      ? glAccounts.map(glAccount => {
        const foundAccount = accounts.find(({ value }) => value === glAccount);

        return {
          label: foundAccount ? foundAccount.label : glAccount,
          value: glAccount,
        };
      })
      : [];

    return (
      <div className="grid-report-cell-editor-popupForm">
        <div>
          {allowSelectingGlAccount && glAccounts && (
            <FormControl
              onChange={this.selectGlAccountOverride}
              validate={validate}
              validationSubscription={validationSubscription}
              name="glAccountOverride"
              label="GL Account Offset"
              value={glAccountOverride.value}
              required
              showErrorByForce={triedToSubmitForm}
              customErrorMessage="Required."
            >
              <Select
                clearable={false}
                options={glAccountsToChooseFrom}
                scrollMenuIntoView={false}
                virtualized
              />
            </FormControl>
          )}
          { (!accountOverride && (requireAccount || allowFromAccount))
            && (
              <FormControl
                onChange={this.selectAdjustment}
                validate={validate}
                validationSubscription={validationSubscription}
                name="taxEntryAccountId"
                label={allowFromAccount ? 'To Account' : 'Account'}
                value={taxEntryAccountId.value}
                required
                showErrorByForce={triedToSubmitForm}
                customErrorMessage="Required."
              >
                <Select
                  clearable={false}
                  options={accounts}
                  scrollMenuIntoView={false}
                  virtualized
                />
              </FormControl>
            )
          }
          { (accountOverride && (requireAccount || allowFromAccount))
            && (
              <div className="form-group row">
                <label className="col-12" htmlFor="taxEntryAccountId">
                  {allowFromAccount ? 'To Account' : 'Account'}
                </label>
                <div className="col-12">
                  <input
                    className="form-control"
                    disabled
                    type="text"
                    name="taxEntryAccountId"
                    value={accountOverride}
                  />
                </div>
              </div>
            )
          }
          {allowFromAccount && (
            <FormControl
              onChange={this.selectFromAdjustment}
              validate={validate}
              validationSubscription={validationSubscription}
              name="fromTaxEntryAccountId"
              label="From Account"
              value={fromTaxEntryAccountId.value}
              required
              showErrorByForce={triedToSubmitForm}
              globalFormError={!areReclassAccountIdsUnique && RECLASS_ACCOUNT_ID_ERROR}
              customErrorMessage="Required."
            >
              <Select
                clearable={false}
                options={accounts}
                scrollMenuIntoView={false}
                virtualized
              />
            </FormControl>
          )}
        </div>
        <div>
          {formHasRequiredFields && (
            <div className="grid-report-cell-editor-moreButton" onClick={toggleDetails}>
              {showDetails
                ? 'Hide Details'
                : 'Edit Details'}
            </div>
          )}
          <div className={classname('grid-report-cell-editor-details', { 'grid-report-cell-editor-details-show': showDetails || !formHasRequiredFields })}>
            {allowTopside && (
              <FormControl
                onChange={changeProperty}
                name="topsideFlag"
                label="Topside"
              >
                <input
                  type="checkbox"
                  checked={topsideFlag.value}
                />
              </FormControl>
            )}
            {
              allowSelectingFbosFlag && (
                <FormControl
                  className="grid-report-cell-editor-fbos-checkbox"
                  name="fbosFlag"
                  label="Generate matching State and FBOS Entries?"
                  onChange={changeProperty}
                >
                  <input
                    type="checkbox"
                    checked={fbosFlag.value}
                  />
                </FormControl>
              )
            }
            <FormControl
              onChange={changeProperty}
              name="comment"
              label="Comment"
              value={comment.value}
            >
              <TextArea maxLength={100} rows={1} resize="vertical"/>
            </FormControl>
            <Attachments
              addFileToForm={addFile}
              removeFileFromForm={removeFile}
              files={files}
              maxFileSize={10}
              showShortDescription
            />
          </div>
        </div>
        { triedToSubmitForm && !amountHasChanged.isValid && <div className="invalid-feedback">{AMOUNT_HAS_CHANGED_ERROR_MESSAGE}</div>}
        <Button
          type="button"
          kind="primary"
          className="float-right submit-tax-entry-button"
          onClick={onSubmit}
        >
          Submit
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  period: selectPeriodFrom(state),
  accounts: accountsSelector(state, ownProps),
});

export default connect(
  mapStateToProps
)(PopupForm);
